<template>
  <div class="loader" :style="styleObj"
       :class="[{'loader--small': isSmall}, {'loader--modal': isLoaderModal}, {'loader--extra-small': isExtraSmall}]"></div>
</template>

<script>
export default {
  props: {
    bgColor: {
      default: '#edf0f5'
    },
    isSmall: {
      type: Boolean,
      default: false
    },
    isExtraSmall: {
      type: Boolean,
      default: false
    },
    isLoaderModal: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    styleObj () {
      return {
        '--bgColor': this.bgColor
      }
    }
  }
}
</script>

<style>
@import "../../assets/css/variables.css";

.loader {
  font-size: 10px;
  margin: 50px auto;
  text-indent: -9999em;
  width: 46px;
  height: 46px;
  border-radius: 50%;
  background: var(--primary);
  background: linear-gradient(to right, var(--primary) 10%, rgba(69, 83, 255, 0) 42%);
  position: relative;
  animation: load3 0.6s infinite linear;
  transform: translateZ(0);
}

.loader.loader--small {
  width: 30px;
  height: 30px;
}

.loader.loader--extra-small {
  width: 22px;
  height: 22px;
}

.loader:before {
  width: 50%;
  height: 50%;
  background: var(--primary);
  border-radius: 100% 0 0 0;
  position: absolute;
  top: 0;
  left: 0;
  content: '';
}

.loader:after {
  background: var(--bgColor);
  width: 82%;
  height: 82%;
  border-radius: 50%;
  content: '';
  margin: auto;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

.loader.loader--modal:after {
  background: #f6f9fc;
}

@-webkit-keyframes load3 {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes load3 {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

</style>



// WEBPACK FOOTER //
// Loader.vue?289933f4